module.exports = "/_next/static/files/e3568cc5ac44673c4bab9e8957da5cb4.jpg";